export const issuers = {
  retail: [
    {
      name: "Alliance Bank Malaysia Berhad",
      label: "Alliance Bank Malaysia Berhad",
      value: "ALLIANCE_BANK_MALAYSIA_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Bank of China (M) Berhad",
      label: "Bank of China (M) Berhad",
      value: "BANK_OF_CHINA_(M)_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Boost Bank",
      label: "Boost Bank",
      value: "BOOST_BANK_RETAIL",
      isActive: true
    },
    {
      name: "Kuwait Finance House",
      label: "Kuwait Finance House",
      value: "KUWAIT_FINANCE_HOUSE_RETAIL",
      isActive: true
    },
    {
      name: "MayBank Berhad",
      label: "MayBank Berhad",
      value: "MAYBANK_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Standard Chartered Bank Malaysia Berhad",
      label: "Standard Chartered Bank Malaysia Berhad",
      value: "STANDARD_CHARTERED_BANK_MALAYSIA_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "MBSB Bank Berhad",
      label: "MBSB Bank Berhad",
      value: "MBSB_BANK_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Agro Bank",
      label: "Agro Bank",
      value: "AGRO_BANK_RETAIL",
      isActive: true
    },
    {
      name: "Ambank Berhad",
      label: "Ambank Berhad",
      value: "AMBANK_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "CIMB Bank",
      label: "CIMB Bank",
      value: "CIMB_BANK_RETAIL",
      isActive: true
    },
    {
      name: "Bank Islam",
      label: "Bank Islam",
      value: "BANK_ISLAM_RETAIL",
      isActive: true
    },
    {
      name: "Bank Kerjasama Rakyat Malaysia Berhad",
      label: "Bank Kerjasama Rakyat Malaysia Berhad",
      value: "BANK_KERJASAMA_RAKYAT_MALAYSIA_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Bank Muamalat",
      label: "Bank Muamalat",
      value: "BANK_MUAMALAT_RETAIL",
      isActive: true
    },
    {
      name: "Bank Simpanan Nasional Berhad",
      label: "Bank Simpanan Nasional Berhad",
      value: "BANK_SIMPANAN_NASIONAL_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Finexus",
      label: "Finexus",
      value: "FINEXUS_RETAIL",
      isActive: true
    },
    {
      name: "HSBC Bank",
      label: "HSBC Bank",
      value: "HSBC_BANK_RETAIL",
      isActive: true
    },
    {
      name: "Hong Leong Bank Berhad",
      label: "Hong Leong Bank Berhad",
      value: "HONG_LEONG_BANK_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "MobilityOne",
      label: "MobilityOne",
      value: "MOBILITYONE_RETAIL",
      isActive: true
    },
    {
      name: "OCBC Bank (Malaysia) Berhad",
      label: "OCBC Bank (Malaysia) Berhad",
      value: "OCBC_BANK_(MALAYSIA)_BERHAD_RETAIL",
      isActive: true
    },
    {
      name: "Public Bank Berhad ",
      label: "Public Bank Berhad ",
      value: "PUBLIC_BANK_BERHAD__RETAIL",
      isActive: true
    },
    {
      name: "Affin Bank",
      label: "Affin Bank",
      value: "AFFIN_BANK_RETAIL",
      isActive: true
    },
    {
      name: "RHB Banking Group",
      label: "RHB Banking Group",
      value: "RHB_BANKING_GROUP_RETAIL",
      isActive: true
    },
    {
      name: "Ryt Bank",
      label: "Ryt Bank",
      value: "RYT_BANK_RETAIL",
      isActive: true
    },
    {
      name: "United Overseas Bank Berhad (UOB)",
      label: "United Overseas Bank Berhad (UOB)",
      value: "UNITED_OVERSEAS_BANK_BERHAD_(UOB)_RETAIL",
      isActive: true
    }
  ],
  corporate: [
    {
      name: "MBSB Bank Berhad",
      label: "MBSB Bank Berhad",
      value: "MBSB_BANK_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "Agro Bank",
      label: "Agro Bank",
      value: "AGRO_BANK_CORPORATE",
      isActive: true
    },
    {
      name: "Ambank Berhad",
      label: "Ambank Berhad",
      value: "AMBANK_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "Bank Islam",
      label: "Bank Islam",
      value: "BANK_ISLAM_CORPORATE",
      isActive: true
    },
    {
      name: "Bank Kerjasama Rakyat Malaysia Berhad",
      label: "Bank Kerjasama Rakyat Malaysia Berhad",
      value: "BANK_KERJASAMA_RAKYAT_MALAYSIA_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "Bank Muamalat",
      label: "Bank Muamalat",
      value: "BANK_MUAMALAT_CORPORATE",
      isActive: true
    },
    {
      name: "CIMB Bank",
      label: "CIMB Bank",
      value: "CIMB_BANK_CORPORATE",
      isActive: true
    },
    {
      name: "Deutsche Bank (Malaysia) Berhad",
      label: "Deutsche Bank (Malaysia) Berhad",
      value: "DEUTSCHE_BANK_(MALAYSIA)_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "MayBank Berhad",
      label: "MayBank Berhad",
      value: "MAYBANK_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "Alliance Bank Malaysia Berhad",
      label: "Alliance Bank Malaysia Berhad",
      value: "ALLIANCE_BANK_MALAYSIA_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "Public Bank Berhad ",
      label: "Public Bank Berhad ",
      value: "PUBLIC_BANK_BERHAD__CORPORATE",
      isActive: true
    },
    {
      name: "Affin Bank",
      label: "Affin Bank",
      value: "AFFIN_BANK_CORPORATE",
      isActive: true
    },
    {
      name: "RHB Banking Group",
      label: "RHB Banking Group",
      value: "RHB_BANKING_GROUP_CORPORATE",
      isActive: true
    },
    {
      name: "Sumitomo Mitsui Banking Corporation (M) Berhad",
      label: "Sumitomo Mitsui Banking Corporation (M) Berhad",
      value: "SUMITOMO_MITSUI_BANKING_CORPORATION_(M)_BERHAD_CORPORATE",
      isActive: true
    },
    {
      name: "United Overseas Bank Berhad (UOB)",
      label: "United Overseas Bank Berhad (UOB)",
      value: "UNITED_OVERSEAS_BANK_BERHAD_(UOB)_CORPORATE",
      isActive: true
    }
  ]
};
